import React from 'react';
import {Link, NavLink, Route, Routes} from "react-router-dom";
import Subscriptions from "../Subscribe/Subscriptions";

export default class SearchCustomers extends React.Component {
   render() {
        return <div>
            <form>
                <input type="text" placeholder="Search..."/>
                <input type="submit" value="submit"/>
            </form>
        </div>;
    }
}
